var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"head"},[_c('university-head')],1),_c('div',{staticClass:"main"},[_c('university-main')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }